import { Validator } from '@vista-digital/validator';
export const seatPositionValidator = Validator.object({
    areaNumber: Validator.number({ min: 1 }),
    columnNumber: Validator.number({ min: 1 }),
    rowNumber: Validator.number({ min: 1 })
});
